import { Suspense, useState } from 'react';
import { ComboBox, ComboBoxFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { useInternalUsers } from 'state';
import { User } from 'types';
import styles from './AssigneeFilter.module.scss';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';

export type AssigneeFilterProps = {
    assignee: User | undefined
    onAssigneeChange: (value: User) => void
};

const placeHolderUser: User = {
    emailAddress: "All",
    firstName: "",
    lastName: "",
    fullName: "",
    disputeQueueId: 0,
    isInternalUser: false,
    isFinalApprover: false,
};

const unassignedUser: User = {
    emailAddress: "Unassigned",
    firstName: "",
    lastName: "",
    fullName: "Unassigned",
    disputeQueueId: 0,
    isInternalUser: false,
    isFinalApprover: false,
}

const AssigneeFIlter = (props: AssigneeFilterProps) => (
    <Suspense>
        <AssigneeDropDown {...props} />
    </Suspense>
);

const AssigneeDropDown = ({assignee, onAssigneeChange}: AssigneeFilterProps) => {
    const users = useInternalUsers();
    const assignees: User[] = [unassignedUser,  ...users];
    const [expanded, setExpanded] = useState(false);
    const [data, setData] = useState<User[]>(assignees);

    assignees.sort((a, b) => (a.firstName > b.firstName ? 1 : -1));
    
    const filterData = (filter: FilterDescriptor) => {
        const data = assignees.slice();
        return filterBy(data, filter);
    };

    const filterChange = (event: ComboBoxFilterChangeEvent) => {
        setData(filterData(event.filter));
    };

    return (
        <span className={styles.assigneeFilterContainer}>     
            <span className={styles.assigneeLabel}>Assignee:</span>
            <ComboBox
                className={styles.assigneeFilter}
                data={data}
                textField={"fullName"} 
                value={assignee ?? placeHolderUser}
                onChange={(e) => onAssigneeChange(e.value as User)}
                defaultValue={placeHolderUser}
                suggest={true}
                filterable={true}
                onFilterChange={filterChange}
                placeholder="All" 
                iconClassName={expanded ? 'k-icon k-i-chevron-up k-svg-icon' : 'k-icon k-i-chevron-down k-svg-icon'}
                onOpen={() => setExpanded(true)}
                onClose={() => setExpanded(false)}
                size="small"
            />
        </span>
    );
};

export default AssigneeFIlter;
